import fonts from './fonts';
import responsive from './responsive';
import spacing from './spacing';

export const secondaryColor = '#8b8b8b';
export const enum directions {
    top = 1,
    bottom = 1 << 1,
    left = 1 << 2,
    right = 1 << 3,
    all = 1 | 1 << 1 | 1 << 2 | 1 << 3,
    sides = 1 << 2 | 1 << 3
};

const prefixed = (prefix: string, value: number, multi: number = 1, dir: directions = directions.sides) => ({
    [prefix ? `${prefix}Left` : 'left']:
        (dir & directions.left) === directions.left && value * multi || undefined,
    [prefix ? `${prefix}Right` : 'right']:
        (dir & directions.right) === directions.right && value * multi || undefined,
    [prefix ? `${prefix}Bottom` : 'bottom']:
        (dir & directions.bottom) === directions.bottom && value * multi || undefined,
    [prefix ? `${prefix}Top` : 'top']:
        (dir & directions.top) === directions.top && value * multi || undefined
});

export const bodyFontSize = {
    'Mobile': 18,
    'Tablet': 20,
    'Laptop': 20,
    'Desktop': 24
}

export const smallTextFontSize = {
    'Mobile': 13,
    'Tablet': 14,
    'Laptop': 15,
    'Desktop': 16
}

export default {
    'Body': {
        ...fonts.FalsterGroteskLight,
        color: secondaryColor,
        [responsive.Mobile]: {
            fontSize: bodyFontSize.Mobile,
            lineHeight: '1.25'
        },
        [responsive.Tablet]: {
            fontSize: bodyFontSize.Tablet,
            lineHeight: '1.25'
        },
        [responsive.Laptop]: {
            fontSize: bodyFontSize.Laptop,
            lineHeight: '1.25'
        },
        [responsive.Desktop]: {
            fontSize: bodyFontSize.Desktop,
            lineHeight: '1.25'
        }
    },
    'SmallText': {
        [responsive.Mobile]: {
            fontSize: smallTextFontSize.Mobile,
            lineHeight: '1.30'
        },
        [responsive.Tablet]: {
            fontSize: smallTextFontSize.Tablet,
            lineHeight: '1.30'
        },
        [responsive.Laptop]: {
            fontSize: smallTextFontSize.Laptop,
            lineHeight: '1.30'
        },
        [responsive.Desktop]: {
            fontSize: smallTextFontSize.Desktop,
            lineHeight: '1.30'
        }
    },
    'PaddingGutter': (multi: number = 1, dir: directions = directions.sides) => ({
        [responsive.Mobile]: prefixed('padding', spacing.Gutter.Mobile, multi, dir),
        [responsive.Tablet]: prefixed('padding', spacing.Gutter.Tablet, multi, dir),
        [responsive.Laptop]: prefixed('padding', spacing.Gutter.Laptop, multi, dir),
        [responsive.Desktop]: prefixed('padding', spacing.Gutter.Desktop, multi, dir),

    }),
    'MarginGutter': (multi: number = 1, dir: directions = directions.sides) => ({
        [responsive.Mobile]: prefixed('margin', spacing.Gutter.Mobile, multi, dir),
        [responsive.Tablet]: prefixed('margin', spacing.Gutter.Tablet, multi, dir),
        [responsive.Laptop]: prefixed('margin', spacing.Gutter.Laptop, multi, dir),
        [responsive.Desktop]: prefixed('margin', spacing.Gutter.Desktop, multi, dir)
    }),
    'PostionGutter': (multi: number = 1, dir: directions = directions.sides) => ({
        [responsive.Mobile]: prefixed('', spacing.Gutter.Mobile, multi, dir),
        [responsive.Tablet]: prefixed('', spacing.Gutter.Tablet, multi, dir),
        [responsive.Laptop]: prefixed('', spacing.Gutter.Laptop, multi, dir),
        [responsive.Desktop]: prefixed('', spacing.Gutter.Desktop, multi, dir)
    })
};


// WEBPACK FOOTER //
// ./src/constants/stylesheet.ts